import { Address } from './address';

export enum UserType {
    Comercial,
    Cliente
}

export interface User {
    addresses: Address[];
    almacenCodigo: string;
    almacenNombre: string;
    cerrarSesion: boolean;
    checkPartsCart: boolean;
    clienteAgencia: string;
    clienteBloqueo: string;
    clienteCodigo: string;
    clienteCp: string;
    clienteDecuentoprontopago: number;
    clienteDescuentoweb: number;
    clienteDireccion: string;
    clienteExentoiva: boolean;
    clienteGenerico: boolean;
    clienteImportediponible: number;
    clienteMunicipio: string;
    clienteNif: string;
    clienteNombre: string;
    clienteObservaciones: string;
    clientePais: string;
    clienteTelefono: string;
    codigopromocion: string;
    comercialNombre: string;
    comercialTelefono: string;
    confirmarPedido: boolean;
    connectif_agente: number;
    connectif_as400: string;
    connectif_cadena: number;
    connectif_email: string;
    connectif_empresa: number;
    connectif_movil: number;
    connectif_provincia: string;
    connectif_suscripcion: boolean;
    connectif_zona: number;
    empresa: number;
    exception: boolean;
    i18nKeyPortes: string;
    incidencias: string;
    iva: number;
    logo1: string;
    logo2: string;
    logob2b: string;
    matriculaYAutorizacionObligatorias: boolean;
    mercado: string;
    modificarPrecio: boolean;
    mostrarMensajeNuevaUrl: boolean;
    mostrarPortes: boolean;
    mostrarPrecio0: boolean;
    name: string;
    nombreEmpresa: string;
    pagoCredito: boolean;
    pagoTarjeta: boolean;
    redireccionaUrl: boolean;
    rutaImagenesBuscadores: string;
    rutaLogoAgencia: string;
    scriptChat: string;
    seleccionarMarcaVehiculo: boolean;
    selectedAddress: number;
    selectedAddressCode: number;
    shipping_address: string;
    shipping_city: string;
    shipping_lastname: string;
    shipping_name: string;
    shipping_phone: string;
    shipping_zip_code: string;
    showPrice: boolean;
    solicitarPedido: boolean;
    tipoPrecioConsejo: string;
    tipoUsuario: string;
    transferenciaBanco: string;
    transferenciaBic: string;
    transferenciaCuenta: string;
    transferenciaEmail: string;
    transferenciaFax: string;
    transferenciaIban: string;
    type: UserType;
    unidadesAdvertencia: boolean;
    urlAyuda: string;
    urlChat: string;
    urlCondiciones: string;
    urlCurrent: string;
    urlExtras: Object;
    urlFavoritopromociones: string;
    urlFichaliente: string;
    urlInfotechnic: string;
    urlIntranet: string;
    urlMacizos: string;
    urlMichelinExclusive: string;
    urlNew: string;
    urlPlataformaVO: string;
    urlPresupuestos: string;
    urlPromosHankook: string;
    urlRecambios: string;
    urlSeguros: string;
    verArticulosOtros: boolean;
    verBotonAyuda: boolean;
    verBotonContacta: boolean;
    verBusqueda4por4: boolean;
    verBusquedaAgricola: boolean;
    verBusquedaCamion: boolean;
    verBusquedaCamioneta: boolean;
    verBusquedaIndustrial: boolean;
    verBusquedaMoto: boolean;
    verBusquedaOtrosproductos: boolean;
    verBusquedaRecambios: boolean;
    verBusquedaSinResultado: boolean;
    verBusquedaTodos: boolean;
    verBusquedaTursimo: boolean;
    verCMS: boolean;
    verCambioVersion: boolean;
    verCodigoPromocion: boolean;
    verConfiguracion: boolean;
    verConfiguracionBaremo: boolean;
    verConfiguracionPrecioConsejo: boolean;
    verConsultaAlbaranes: boolean;
    verConsultaArticulosstockexterno: boolean;
    verConsultaDocumentos: boolean;
    verConsultaFacturas: boolean;
    verConsultaIncidencias: boolean;
    verConsultaPedidos: boolean;
    verConsultaPedidosb2c: boolean;
    verConsultaPedidosreferencia: boolean;
    verConsultaVencimientos: boolean;
    verEquivalencias: boolean;
    verEquivalenciasAgricola: boolean;
    verFavoritopromociones: boolean;
    verFiltroMarca: boolean;
    verFleet: boolean;
    verInfoComercial: boolean;
    verInfotechnic: boolean;
    verIntranet: boolean;
    verMacizos: boolean;
    verMenuPromociones: boolean;
    verMenuRegalos: boolean;
    verMichelinExclusive: boolean;
    verNfu: boolean;
    verObsoletos: boolean;
    verOfertas: boolean;
    verOpiniones: boolean;
    verPlataformaVO: boolean;
    verPrecioreferencia: boolean;
    verPresupuestos: boolean;
    verPromoHankook: boolean;
    verPuntos: boolean;
    verRappel: boolean;
    verReferencia: boolean;
    verSeguros: boolean;
    verbotOnContacto: boolean;
    versionb2b: string;
}

export class UserHelper {
    static createExceptionUser(): User {
        let tmpUser = UserHelper.create();
        tmpUser.exception = true;
        return tmpUser;
    }
    static create(): User {
        return {
            exception: false,
            clienteCodigo: '',
            clienteNombre: '',
            clienteNif: '',
            clienteDireccion: '',
            clienteCp: '',
            clienteMunicipio: '',
            clientePais: '',
            clienteBloqueo: '',
            clienteExentoiva: false,
            clienteObservaciones: '',
            clienteImportediponible: 0,
            clienteTelefono: '',
            clienteAgencia: '',
            clienteDecuentoprontopago: 0,
            clienteDescuentoweb: 0,

            almacenCodigo: '',
            almacenNombre: '',

            logo1: '',
            logo2: '',
            logob2b: '',

            codigopromocion: '',

            verCodigoPromocion: false,
            verConsultaPedidos: false,
            verConsultaAlbaranes: false,
            verConsultaFacturas: false,
            verConsultaVencimientos: false,
            verConsultaDocumentos: false,
            verConsultaPedidosb2c: false,
            verConsultaIncidencias: false,
            verConsultaPedidosreferencia: false,
            verConsultaArticulosstockexterno: false,
            verPromoHankook: false,
            verPlataformaVO: false,
            verSeguros: false,

            verPrecioreferencia: false,
            verBotonContacta: false,
            verBotonAyuda: false,
            verArticulosOtros: false,
            verFiltroMarca: false,
            verReferencia: false,
            verConfiguracion: false,
            verPuntos: false,
            verCMS: false,

            verFavoritopromociones: false,
            urlFavoritopromociones: '',
            urlIntranet: '',
            urlFichaliente: '',
            urlChat: '',
            urlCondiciones: '',
            urlAyuda: '',
            urlPresupuestos: '',
            urlRecambios: '',
            urlCurrent: '',
            urlNew: '',
            urlPlataformaVO: '',
            urlSeguros: '',
            urlPromosHankook: '',
            urlMacizos: '',

            verBusquedaTursimo: false,
            verBusquedaCamioneta: false,
            verBusquedaMoto: false,
            verBusqueda4por4: false,
            verBusquedaCamion: false,
            verBusquedaAgricola: false,
            verBusquedaIndustrial: false,
            verBusquedaOtrosproductos: false,
            verBusquedaRecambios: false,
            verBusquedaSinResultado: false,
            verBusquedaTodos: false,
            verFleet: false,
            verIntranet: false,
            verMacizos: false,
            verNfu: false,
            verOpiniones: false,
            verObsoletos: false,
            verPresupuestos: false,
            verConfiguracionBaremo: false,
            verInfotechnic: false,
            urlInfotechnic: '',
            confirmarPedido: false,
            solicitarPedido: false,
            i18nKeyPortes: '',
            clienteGenerico: false,
            pagoCredito: false,
            pagoTarjeta: false,
            scriptChat: '',
            seleccionarMarcaVehiculo: false,
            tipoUsuario: '',
            modificarPrecio: false,
            iva: 0,
            empresa: 0,
            mostrarPortes: false,
            versionb2b: '',
            cerrarSesion: false,
            unidadesAdvertencia: false,
            incidencias: '',
            mercado: '',
            mostrarPrecio0: false,
            verbotOnContacto: false,
            nombreEmpresa: '',
            verConfiguracionPrecioConsejo: false,
            tipoPrecioConsejo: '',
            comercialNombre: '',
            comercialTelefono: '',
            rutaLogoAgencia: '',
            rutaImagenesBuscadores: '',
            verCambioVersion: false,

            addresses: [],
            selectedAddress: undefined,
            selectedAddressCode: undefined,
            urlExtras: null,
            showPrice: false,
            verRappel: false,
            verEquivalencias: false,
            verEquivalenciasAgricola: false,

            verOfertas: false,

            verInfoComercial: false,
            verMichelinExclusive: false,
            urlMichelinExclusive: '',
            name: '',

            type: UserType.Cliente,

            shipping_name: '',
            shipping_lastname: '',
            shipping_address: '',
            shipping_city: '',
            shipping_zip_code: '',
            shipping_phone: '',

            transferenciaBanco: '',
            transferenciaBic: '',
            transferenciaCuenta: '',
            transferenciaEmail: '',
            transferenciaFax: '',
            transferenciaIban: '',

            checkPartsCart: false,

            connectif_email: '',
            connectif_empresa: 0,
            connectif_agente: 0,
            connectif_cadena: 0,
            connectif_provincia: '',
            connectif_as400: '',
            connectif_zona: 0,
            connectif_movil: 0,
            connectif_suscripcion: false,

            verMenuPromociones: false,

            matriculaYAutorizacionObligatorias: false,
            verMenuRegalos: false,
            redireccionaUrl: false,
            mostrarMensajeNuevaUrl: false
        };
    }

    /**
     * @brief      Create a user from api data
     *
     * @param      apiData           The user data from api
     * @param      authStringExtras  Auth string to replace params in extra urls
     *
     * @return     User created
     */
    static transformFromApi(apiData: Object, authStringExtras: string = '', environment: any = {}) {
        // User Creation
        const user = UserHelper.create();

        user.urlExtras = {};

        // Url Extras
        Object.assign(user.urlExtras, environment.linkedApps);
        // eslint-disable-next-line guard-for-in
        for (const item in user.urlExtras) {
            user.urlExtras[item] = user.urlExtras[item].replace('%PARAMS%', authStringExtras);
        }
        user.urlExtras['fleetOnTime'] = apiData['URL_FLEET']
            ? apiData['URL_FLEET'].replace('%PARAMS%', authStringExtras)
            : '';
        // Raw data
        user.clienteCodigo = apiData['CL_CODIGO'] ? apiData['CL_CODIGO'] : '';
        user.clienteNombre = apiData['CL_NOMBRE'] ? apiData['CL_NOMBRE'] : '';
        user.clienteNif = apiData['CL_NIF'] ? apiData['CL_NIF'] : '';
        user.clienteDireccion = apiData['CL_DIRECCION'] ? apiData['CL_DIRECCION'] : '';
        user.clienteCp = apiData['CL_CP'] ? apiData['CL_CP'] : '';
        user.clienteMunicipio = apiData['CL_MUNICIPIO'] ? apiData['CL_MUNICIPIO'] : '';
        user.clientePais = apiData['CL_PAIS'] ? apiData['CL_PAIS'] : '';
        user.clienteBloqueo = apiData['CL_BLOQUEO'] ? apiData['CL_BLOQUEO'] : '';
        user.clienteExentoiva = apiData['CL_EXENTOIVA'] ? apiData['CL_EXENTOIVA'] : false;
        user.clienteObservaciones = apiData['CL_OBSERVACIONES'] ? apiData['CL_OBSERVACIONES'] : '';
        user.clienteImportediponible = apiData['CL_IMPORTEDIPONIBLE'] ? apiData['CL_IMPORTEDIPONIBLE'] : 0;
        user.clienteTelefono = apiData['CL_TELEFONO'] ? apiData['CL_TELEFONO'] : '';
        user.clienteAgencia = apiData['CL_AGENCIA'] ? apiData['CL_AGENCIA'] : '';
        user.clienteDecuentoprontopago = apiData['CL_DECUENTOPRONTOPAGO'] ? apiData['CL_DECUENTOPRONTOPAGO'] : 0;
        user.clienteDescuentoweb = apiData['CL_DESCUENTOWEB'] ? apiData['CL_DESCUENTOWEB'] : 0;

        user.almacenCodigo = apiData['AL_CODIGO'] ? apiData['AL_CODIGO'] : '';
        user.almacenNombre = apiData['AL_NOMBRE'] ? apiData['AL_NOMBRE'] : '';

        user.logo1 = apiData['LOGO1'] ? apiData['LOGO1'] : '';
        user.logo2 = apiData['LOGO2'] ? apiData['LOGO2'] : '';
        user.logob2b = apiData['LOGOB2B'] ? apiData['LOGOB2B'] : '';

        user.codigopromocion = apiData['CODIGOPROMOCION'] ? apiData['CODIGOPROMOCION'] : '';

        user.verConsultaPedidos = apiData['VERCONSULTAPEDIDOS'] ? apiData['VERCONSULTAPEDIDOS'] : false;
        user.verConsultaAlbaranes = apiData['VERCONSULTAALBARANES'] ? apiData['VERCONSULTAALBARANES'] : false;
        user.verConsultaFacturas = apiData['VERCONSULTAFACTURAS'] ? apiData['VERCONSULTAFACTURAS'] : false;
        user.verConsultaVencimientos = apiData['VERCONSULTAVENCIMIENTOS'] ? apiData['VERCONSULTAVENCIMIENTOS'] : false;
        user.verConsultaDocumentos = apiData['VERCONSULTADOCUMENTOS'] ? apiData['VERCONSULTADOCUMENTOS'] : false;
        user.verConsultaPedidosb2c = apiData['VERCONSULTAPEDIDOSB2C'] ? apiData['VERCONSULTAPEDIDOSB2C'] : false;
        user.verConsultaIncidencias = apiData['VERCONSULTAINCIDENCIAS'] ? apiData['VERCONSULTAINCIDENCIAS'] : false;
        user.verConsultaPedidosreferencia = apiData['VERCONSULTAPEDIDOSREFERENCIA']
            ? apiData['VERCONSULTAPEDIDOSREFERENCIA']
            : false;
        user.verConsultaArticulosstockexterno = apiData['VERCONSULTAARTICULOSSTOCKEXTERNO']
            ? apiData['VERCONSULTAARTICULOSSTOCKEXTERNO']
            : false;
        user.verPrecioreferencia = apiData['VERPRECIOREFERENCIA'] ? apiData['VERPRECIOREFERENCIA'] : false;
        user.verBotonContacta = apiData['VERBOTONCONTACTA'] ? apiData['VERBOTONCONTACTA'] : false;
        user.verBotonAyuda = apiData['VERBOTONAYUDA'] ? apiData['VERBOTONAYUDA'] : false;
        user.verArticulosOtros = apiData['VERARTICULOSOTROS'] ? apiData['VERARTICULOSOTROS'] : false;
        user.verFiltroMarca = apiData['VERFILTROMARCA'] ? apiData['VERFILTROMARCA'] : false;
        user.verReferencia = apiData['VERREFERENCIA'] ? apiData['VERREFERENCIA'] : false;
        user.verConfiguracion = apiData['VERCONFIGURACION'] ? apiData['VERCONFIGURACION'] : false;
        user.verPuntos = apiData['VERPUNTOS'] ? apiData['VERPUNTOS'] : false;

        user.verCodigoPromocion = apiData['VERCODIGOPROMOCION'] ? apiData['VERCODIGOPROMOCION'] : false;

        user.verFavoritopromociones = apiData['VERFAVORITOPROMOCIONES'] ? apiData['VERFAVORITOPROMOCIONES'] : false;

        user.verBusquedaTursimo = apiData['VERBUSQUEDATURSIMO'] ? apiData['VERBUSQUEDATURSIMO'] : false;
        user.verBusquedaCamioneta = apiData['VERBUSQUEDACAMIONETA'] ? apiData['VERBUSQUEDACAMIONETA'] : false;
        user.verBusquedaMoto = apiData['VERBUSQUEDAMOTO'] ? apiData['VERBUSQUEDAMOTO'] : false;
        user.verBusqueda4por4 = apiData['VERBUSQUEDA4Por4'] ? apiData['VERBUSQUEDA4Por4'] : false;
        user.verBusquedaCamion = apiData['VERBUSQUEDACAMION'] ? apiData['VERBUSQUEDACAMION'] : false;
        user.verBusquedaAgricola = apiData['VERBUSQUEDAAGRICOLA'] ? apiData['VERBUSQUEDAAGRICOLA'] : false;
        user.verBusquedaIndustrial = apiData['VERBUSQUEDAINDUSTRIAL'] ? apiData['VERBUSQUEDAINDUSTRIAL'] : false;
        user.verBusquedaOtrosproductos = apiData['VERBUSQUEDAOTROSPRODUCTOS']
            ? apiData['VERBUSQUEDAOTROSPRODUCTOS']
            : false;
        user.verBusquedaRecambios = apiData['VERBUSQUEDARECAMBIOS'] ? apiData['VERBUSQUEDARECAMBIOS'] : false;
        user.verBusquedaTodos = apiData['VERBUSQUEDATODOS'] ? apiData['VERBUSQUEDATODOS'] : false;
        user.verOpiniones = apiData['VEROPINIONES'] ? apiData['VEROPINIONES'] : false;
        user.verBusquedaSinResultado = apiData['VERBUSQUEDASINRESULTADO'] ? apiData['VERBUSQUEDASINRESULTADO'] : false;
        user.verObsoletos = apiData['VEROBSOLETOS'] ? apiData['VEROBSOLETOS'] : false;
        user.verConfiguracionBaremo = apiData['VERCONFIGURACIONBAREMO'] ? apiData['VERCONFIGURACIONBAREMO'] : false;
        user.verCMS = apiData['MOSTRAR_CMS'] ? apiData['MOSTRAR_CMS'] : false;
        user.verMichelinExclusive = apiData['VERMICHELINEXCLUSIVE'] ? apiData['VERMICHELINEXCLUSIVE'] : false;
        user.urlMichelinExclusive = apiData['URL_MICHELINEXCLUSIVE'] ? apiData['URL_MICHELINEXCLUSIVE'] : '';
        user.verInfotechnic = apiData['VERINFOTECHNIC'] ? apiData['VERINFOTECHNIC'] : false;
        user.urlInfotechnic = apiData['URL_INFOTECHNIC'] ? apiData['URL_INFOTECHNIC'] : '';
        user.confirmarPedido = apiData['CONFIRMARPEDIDO'] ? apiData['CONFIRMARPEDIDO'] : false;
        user.solicitarPedido = apiData['SOLICITARPEDIDO'] ? apiData['SOLICITARPEDIDO'] : false;
        user.i18nKeyPortes = apiData['I18NKEYPORTES'] ? apiData['I18NKEYPORTES'] : '';
        user.clienteGenerico = apiData['CLIENTEGENERICO'] ? apiData['CLIENTEGENERICO'] : false;
        user.pagoCredito = apiData['PAGOCREDITO'] ? apiData['PAGOCREDITO'] : false;
        user.pagoTarjeta = apiData['PAGOTARJETA'] ? apiData['PAGOTARJETA'] : false;
        user.urlFichaliente = apiData['URLFICHALIENTE'] ? apiData['URLFICHALIENTE'] : '';
        user.urlChat = apiData['URLCHAT'] ? apiData['URLCHAT'] : '';
        user.scriptChat = apiData['SCRIPTCHAT'] ? apiData['SCRIPTCHAT'] : '';
        user.seleccionarMarcaVehiculo = apiData['SELECCIONARMARCAVEHICULO']
            ? apiData['SELECCIONARMARCAVEHICULO']
            : false;
        user.tipoUsuario = apiData['TIPOUSUARIO'] ? apiData['TIPOUSUARIO'] : '';

        user.modificarPrecio = apiData['MODIFICARPRECIO'] ? apiData['MODIFICARPRECIO'] : false;
        user.iva = apiData['IVA'] ? apiData['IVA'] : 0;

        user.empresa = apiData['EMPRESA'] ? apiData['EMPRESA'] : '';
        user.mostrarPortes = apiData['MOSTRAR_PORTES'] ? apiData['MOSTRAR_PORTES'] : '';
        user.versionb2b = apiData['VERSIONB2B'] ? apiData['VERSIONB2B'] : '';
        user.verFleet = apiData['VERFLEET'] ? apiData['VERFLEET'] : '';
        user.verPresupuestos = apiData['VERPRESUPUESTOS'] ? apiData['VERPRESUPUESTOS'] : '';
        user.verNfu = apiData['VERNFU'] ? apiData['VERNFU'] : '';
        user.verIntranet = apiData['VERINTRANET'] ? apiData['VERINTRANET'] : '';
        user.verPromoHankook = apiData['VERPROMOSHANKOOK'] ? apiData['VERPROMOSHANKOOK'] : '';
        user.verPlataformaVO = apiData['VERPLATAFORMAVO'] ? apiData['VERPLATAFORMAVO'] : '';
        user.verSeguros = apiData['VERSEGUROS'] ? apiData['VERSEGUROS'] : '';
        user.cerrarSesion = apiData['CERRARSESION'] ? apiData['CERRARSESION'] : '';
        user.unidadesAdvertencia = apiData['UNIDADESADVERTENCIA'] ? apiData['UNIDADESADVERTENCIA'] : '';
        user.incidencias = apiData['INCIDENCIAS'] ? apiData['INCIDENCIAS'] : '';
        user.mercado = apiData['MERCADO'] ? apiData['MERCADO'] : '';
        user.mostrarPrecio0 = apiData['MOSTRARPRECIO0'] ? apiData['MOSTRARPRECIO0'] : false;
        user.verbotOnContacto = apiData['VERBOTONCONTACTO'] ? apiData['VERBOTONCONTACTO'] : false;
        user.nombreEmpresa = apiData['NOMBREEMPRESA'] ? apiData['NOMBREEMPRESA'] : '';
        user.urlCondiciones = apiData['URL_CONDICIONES'] ? apiData['URL_CONDICIONES'] : '';
        user.urlAyuda = apiData['URL_AYUDA'] ? apiData['URL_AYUDA'] : '';
        user.urlCurrent = apiData['URLCURRENT'] ? apiData['URLCURRENT'] : '';
        user.urlNew = apiData['URLNEW'] ? apiData['URLNEW'] : '';
        user.urlIntranet = apiData['URL_INTRANET'] ? apiData['URL_INTRANET'] : '';
        user.urlPresupuestos = apiData['URL_PRESUPUESTOS'] ? apiData['URL_PRESUPUESTOS'] : '';
        user.urlRecambios = apiData['URL_RECAMBIOS'] ? apiData['URL_RECAMBIOS'] : '';
        user.urlFavoritopromociones = apiData['URLFAVORITOPROMOCIONES'] ? apiData['URLFAVORITOPROMOCIONES'] : '';
        user.urlPlataformaVO = apiData['URL_PLATAFORMAVO'] ? apiData['URL_PLATAFORMAVO'] : '';
        user.urlSeguros = apiData['URL_SEGUROS'] ? apiData['URL_SEGUROS'] : '';
        user.urlPromosHankook = apiData['URL_PROMOSHANKOOK'] ? apiData['URL_PROMOSHANKOOK'] : '';

        user.verConfiguracionPrecioConsejo = apiData['VERCONFIGURACIONPRECIOCONSEJO']
            ? apiData['VERCONFIGURACIONPRECIOCONSEJO']
            : false;
        user.tipoPrecioConsejo = apiData['TIPOPRECIOCONSEJO'] ? apiData['TIPOPRECIOCONSEJO'] : 'PVR';

        user.comercialNombre = apiData['COMERCIAL_NOMBRE'] ? apiData['COMERCIAL_NOMBRE'] : '';
        user.comercialTelefono = apiData['COMERCIAL_TELEFONO'] ? apiData['COMERCIAL_TELEFONO'] : '';
        user.rutaLogoAgencia = apiData['RUTA_LOGO_AGENCIAS'] ? apiData['RUTA_LOGO_AGENCIAS'] : '';
        user.rutaImagenesBuscadores = apiData['RUTA_IMAGENES_BUSCADORES'] ? apiData['RUTA_IMAGENES_BUSCADORES'] : '';

        user.verCambioVersion = apiData['MOSTRAR_CAMBIO_VERSION'] ? apiData['MOSTRAR_CAMBIO_VERSION'] : false;
        user.verRappel = apiData['VERRAPPEL'] ? apiData['VERRAPPEL'] : false;
        user.verEquivalencias = apiData['MOSTRAR_OPCION_EQUIVALENCIAS']
            ? apiData['MOSTRAR_OPCION_EQUIVALENCIAS']
            : false;
        user.verEquivalenciasAgricola = apiData['MOSTRAR_OPCION_EQUIVALENCIAS_AGRICOLA']
            ? apiData['MOSTRAR_OPCION_EQUIVALENCIAS_AGRICOLA']
            : false;

        user.verOfertas = apiData['MOSTRAR_OPCION_OFERTAS_ESPECIALES']
            ? apiData['MOSTRAR_OPCION_OFERTAS_ESPECIALES']
            : false;

        user.verInfoComercial = apiData['VER_INFO_COMERCIAL'] ? apiData['VER_INFO_COMERCIAL'] : false;

        user.transferenciaBanco = apiData['TRANSFERENCIA_BANCO'] ? apiData['TRANSFERENCIA_BANCO'] : '';
        user.transferenciaBic = apiData['TRANSFERENCIA_BIC'] ? apiData['TRANSFERENCIA_BIC'] : '';
        user.transferenciaCuenta = apiData['TRANSFERENCIA_CUENTA'] ? apiData['TRANSFERENCIA_CUENTA'] : '';
        user.transferenciaEmail = apiData['TRANSFERENCIA_EMAIL'] ? apiData['TRANSFERENCIA_EMAIL'] : '';
        user.transferenciaFax = apiData['TRANSFERENCIA_FAX'] ? apiData['TRANSFERENCIA_FAX'] : '';
        user.transferenciaIban = apiData['TRANSFERENCIA_IBAN'] ? apiData['TRANSFERENCIA_IBAN'] : '';

        user.checkPartsCart = apiData['COMPROBAR_CONFIRMACION'] ? apiData['COMPROBAR_CONFIRMACION'] : false;

        user.connectif_email = apiData['EMAILUSUARIO'] ? apiData['EMAILUSUARIO'].trim() : '';
        user.connectif_empresa = apiData['EMPRESA'] ? apiData['EMPRESA'] : 0;
        user.connectif_agente = apiData['CL_AGENTE1'] ? apiData['CL_AGENTE1'] : 0;
        user.connectif_cadena = apiData['CL_CADENA'] ? apiData['CL_CADENA'] : 0;
        user.connectif_provincia = apiData['CL_PROVINCIA'] ? apiData['CL_PROVINCIA'].trim() : '';
        user.connectif_as400 = apiData['CL_CODIGO'] ? apiData['CL_CODIGO'] : '';
        user.connectif_zona = apiData['CL_ZONA'] ? apiData['CL_ZONA'] : 0;
        user.connectif_movil = apiData['CL_TELEFONO'] ? apiData['CL_TELEFONO'] : 0;
        user.connectif_suscripcion = apiData['SUSCRITO_NOTIFICACIONES'] ? apiData['SUSCRITO_NOTIFICACIONES'] : false;

        user.verMenuPromociones = apiData['VERPROMOS'] ? apiData['VERPROMOS'] : false;

        user.matriculaYAutorizacionObligatorias = apiData['SOLICITARAUTORIZACIONYMATRICULA']
            ? apiData['SOLICITARAUTORIZACIONYMATRICULA']
            : false;

        user.verMenuRegalos = apiData['VERREGALOS'] ? apiData['VERREGALOS'] : false;

        user.redireccionaUrl = apiData['REDIRECCIONARURL'] ? apiData['REDIRECCIONARURL'] : false;
        user.mostrarMensajeNuevaUrl = apiData['MOSTRARMENSAJENUEVAURL'] ? apiData['MOSTRARMENSAJENUEVAURL'] : false;

        if (user.tipoUsuario === 'COMERCIAL') {
            user.type = UserType.Comercial;
        }

        // Calculate options
        user.showPrice = apiData['MOSTRARPRECIO0'] !== true;

        user.verMacizos = apiData['VERBUSQUEDAMACIZOS'] ? apiData['VERBUSQUEDAMACIZOS'] : false;
        user.urlMacizos = apiData['URL_MACIZOS'] ? apiData['URL_MACIZOS'].replace('##TOKEN##', authStringExtras) : '';
        return user;
    }

    static getUserDefaultIndexAddress(user: User): number {
        const addresses = user.addresses;
        if (addresses && addresses.length > 0) {
            for (let i = addresses.length - 1; i >= 0; i--) {
                if (addresses[i].defecto === true) {
                    return i;
                }
            }
            return addresses.length - 1;
        }
    }

    static getUserDefaultAddress(user: User): Address {
        if (!user.addresses || !user.addresses.length) return null;
        const addresses = user.addresses && user.addresses.length ? [...user.addresses].reverse() : [];
        let ret = addresses.find((a) => a.defecto);
        if (!ret) {
            ret = addresses[0];
        }
        return ret;
    }

    static getUserAddressesIds(user: User): Array<Number> {
        const addressesIdsArray = [];
        user.addresses.map((it) => {
            addressesIdsArray.push(it.codigo);
        });
        return addressesIdsArray;
    }

    static getSelectedAddress(user: User): Address {
        const id = UserHelper.getAddressDefault(user);
        let add = user && user.addresses && user.addresses.length ? user.addresses.find((i) => i.id === id) : null;
        if (!add && user.addresses && user.addresses.length) {
            add = user.addresses[user.addresses.length - 1];
        }
        return add;
    }

    static getType(user: User): string {
        return user.type === UserType.Comercial ? 'Comercial' : 'Cliente';
    }

    static getAddressDefault(user: User): number {
        if (user.addresses) {
            if (user.addresses.length > 1) {
                for (let i = user.addresses.length - 1; i >= 0; i--) {
                    if (user.addresses[i].defecto === true) {
                        return user.addresses[i].id;
                    }
                }
                return user.addresses[user.addresses.length - 1].id;
            }
            return user.addresses.length ? user.addresses[0].id : undefined;
        }
        return;
    }

    static getAddressCodeDefault(user: User): number {
        if (user.addresses) {
            if (user.addresses.length > 1) {
                for (let i = user.addresses.length - 1; i >= 0; i--) {
                    if (user.addresses[i].defecto === true) {
                        return user.addresses[i].codigo;
                    }
                }
                return user.addresses[user.addresses.length - 1].codigo;
            }
            return user.addresses.length ? user.addresses[0].codigo : undefined;
        }
        return;
    }
}
